import { Injectable } from '@angular/core';
import { LocalDbService } from '../local-db-service';
import { Approver } from '../../entities/approver';

@Injectable({ providedIn: 'root' })
export class ApproverRepository {
  private get table() {
    return this.db.approverTable;
  }

  constructor(private readonly db: LocalDbService) {}

  async getAll(): Promise<Approver[]> {
    const rows = await this.table.toArray();
    return rows.map(row => new Approver(row));
  }

  async getByIdAndLocationId(id: number, locationId: number): Promise<Approver | undefined> {
    const row = await this.table.get([id, locationId]);
    return row ? new Approver(row) : undefined;
  }

  async getByLocationId(locationId: number, isForContractor: boolean): Promise<Approver | null> {
    const row = await this.table
        .filter(row => row.locationId === locationId && row.isForContractor === isForContractor)
        .first();
    return row ? new Approver(row) : null;
  }

  upsert(approver: Approver): Promise<[number, number]> {
    return this.table.put(approver);
  }

  upsertBulk(approvers: Approver[]): Promise<[number, number]> {
    return this.table.bulkPut(approvers);
  }

  delete(id: number, locationId: number): Promise<void> {
    return this.table.delete([id, locationId]);
  }

  clear(): Promise<void> {
    return this.table.clear();
  }
}
